<span [class.h1]="tipo == 'h1'">
	{{ propriedadeNome }}
	<ion-skeleton-text *ngIf="!propriedadeNome" animated style="width: 90px"></ion-skeleton-text>
</span>
